import React from "react";
import { Portal as RadixPortal } from "@radix-ui/react-portal";
import { usePortal } from "hooks";

export function PortalMount({
  to,
  replace = false,
  asChild,
  children,
  ...props
}) {
  const container = usePortal({ elementId: to, replace });
  return (
    <RadixPortal container={container} asChild={asChild} {...props}>
      {children}
    </RadixPortal>
  );
}
